<script setup lang="ts">
import type { PreparedAuctionItem } from '@autobid/ui/types/components/AuctionsData'
import { useAutobidAuth } from '@autobid/nuxt-auth/src/composables/useAutobidAuth'
import { useAccessToAuction } from '@autobid/ui/composables/useAccessToAuction'
import AuctionListItemInfoElement from './AuctionListItemInfoElement.vue'

const { restrictions, appId, type } = inject('auction') as PreparedAuctionItem

const { isAuthed } = useAutobidAuth()
const accessToAuction = useAccessToAuction({
  restrictions,
  appId,
  isAuthed,
})
</script>

<template>
  <AuctionListItemInfoElement
    v-if="accessToAuction.statusCode === 403 && type !== 'LIVE'"
    icon="material-symbols:lock"
    class="text-red"
  >
    <span class="text-sm"> {{ $t('auction-list.no-access') }} </span>
  </AuctionListItemInfoElement>
</template>
